import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import './PlanFeaturesSection.css';

const PlanFeaturesSection = ({ title, features }) => {
  return (
    <div className="plan-features-section py-3">
      {title && <h2 className="text-center mb-4">{title}</h2>}
      <Row xs={1} md={2} lg={4} className="g-4">
        {features.map((feature, index) => (
          <Col key={index}>
            <Card className="h-100 text-center plan-features-section-card">
              <Card.Body>
                <div className="feature-icon mb-2" style={{ fontSize: '2rem' }}>{feature.icon}</div>
                <Card.Title className="plan-features-section-card-title">{feature.title}</Card.Title>
                <Card.Text className="plan-features-section-card-description">
                  {feature.description}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default PlanFeaturesSection;
